<template>
  <div style="display: flex;flex-direction: column">
    <CategoriesSection/>
    <FeaturesSection/>
  </div>

</template>

<script>
import CategoriesSection from "@/components/CategoriesSection.vue";
import FeaturesSection from "@/components/FeaturesSection.vue";

export default {
  name: 'HomeContent',
  components: {FeaturesSection, CategoriesSection}
};
</script>
